import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSignOut = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 10.5,
	viewBox: "0 0 12 10.5",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("g", { id: "a" }),
		/* @__PURE__ */ _jsx("g", {
			id: "b",
			children: /* @__PURE__ */ _jsx("g", {
				id: "c",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M4.5,9.94c0,.31-.25,.56-.56,.56h-1.69c-1.24,0-2.25-1.01-2.25-2.25V2.25C0,1.01,1.01,0,2.25,0h1.69c.31,0,.56,.25,.56,.56s-.25,.56-.56,.56h-1.69c-.62,0-1.12,.51-1.12,1.12v6c0,.62,.51,1.12,1.12,1.12h1.69c.31,0,.56,.25,.56,.56Zm7.35-5.07l-2.98-3.19c-.21-.23-.57-.24-.79-.02-.23,.21-.24,.57-.02,.79l2.08,2.24H4.29c-.29,0-.54,.25-.54,.56s.25,.56,.54,.56h5.82l-2.11,2.24c-.21,.23-.2,.58,.02,.79,.13,.1,.27,.15,.39,.15,.15,0,.3-.06,.41-.18l2.98-3.19c.25-.22,.25-.55,.04-.77Z",
					fill: "#231f20"
				})
			})
		})
	]
});
const ForwardRef = forwardRef(SvgSignOut);
export default ForwardRef;
